import {Component, OnInit, Input, Output, EventEmitter, NgZone, ChangeDetectorRef} from '@angular/core';

import {AppComponent} from './app.component';
import {StockArticleService} from './stock-article.service';
import {ImportItemsService} from './import-items.service';
import {TransferRequestService} from './transfer-request.service';


@Component({
    selector: 'stock-article',
    templateUrl: './templates/stock-article.component.html',
    styleUrls: ['./styles/stock-article.component.css'],
    providers: [StockArticleService]
})
export class StockArticleComponent implements OnInit {

    @Output() article_to_send = new EventEmitter();
    @Output() change_warehouse = new EventEmitter();

    @Input() type_parent = 'default';
    @Input() articles_list: Array<any> = [];

    article_name: string;
    article_name_trans: string;
    //    articles_list: Array<any> = [];

    warehouse: string;
    warehouses_list: Array<any>;
    test: number = 0;

    constructor(
        private app_component: AppComponent,
        private import_items_service: ImportItemsService,
        private stock_article_service: StockArticleService,
        private transfer_request_service: TransferRequestService,

    ) {
        /*setInterval(() => {           // the following is required, otherwise the view will not be updated
            this.ref.markForCheck();
        }, 1000);*/
        /*ref.detach();
        setInterval(() => {
            this.ref.detectChanges();
        }, 1000);*/
    }


    ngOnInit() {
        if (this.type_parent === 'transfer') {
            this.getWarehousesListTransfer();
        } else {
            this.getWarehousesList();
            this.getArticles();
            this.warehouse = undefined;
        }
        //        console.log(this.new_insert);
    }

    doSomething(article: any) {
        this.article_to_send.emit(article);
    }

    getArticles() {

        this.stock_article_service.getArticles(this.article_name)
            .then(response => {
                //console.log(response);
                this.articles_list = response;
            });
    }

    getWarehousesList(): void {
        this.import_items_service.getWarehouses()
            .then(result => {
                this.warehouses_list = result['list'];
            });
    }

    changed(event: any) {
        this.warehouse = event;
        this.article_name_trans = undefined;
        this.getArticlesTransfer();
        this.article_name_trans = '';
        this.change_warehouse.emit('YES');
    }

    getArticlesTransfer() {
        this.stock_article_service.getArticlesTransfer(this.warehouse, this.article_name_trans)
            .then(response => {
                this.articles_list = response;
            });
    }

    getWarehousesListTransfer(): void {
        this.import_items_service.getWarehouses()
            .then(result => {
                this.warehouses_list = result['list'];
                if (this.type_parent == 'transfer') {
                    this.warehouse = result['list'][0]['name'];
                    this.changed(this.warehouse);
                }
            });
    }

    setStyles(art: any) {
        //  console.log(art)
        let styles = {
            'color': 'red',
        };

        if (parseInt(art.stocks) != 0) {
            if (parseInt(art.stocks) >= parseInt(art.supply_thershold)) {
                styles = {'color': 'black'};
            } else {
                styles = {'color': 'orange'};
            }
        }

        return styles;
    }

    selected_tr: number = -1;
    Selected(value: number): void{
        this.selected_tr = value;
    }
    
    Color(index: number) {
//        console.log(index);
//        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {
                
                'background-color': '#B3B6B7', //'#FFB400',
                //'color': 'orange',
            };
        }

        return styles;
    }
    
    ColorIndex(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {

                //'background-color': '#B3B6B7', //'#FFB400',
                'color': 'white',
            };
        }

        return styles;
    }
    
}



// WEBPACK FOOTER //
// ./src/app/stock-article.component.ts